import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { employeeApi } from '../../api/hr';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';

/** Non-sensitive fields only, per Section 29 - name/position/department/duty station/official email, nothing more. */
export function StaffDirectoryPage() {
  const directoryQuery = useQuery({ queryKey: ['staff-directory'], queryFn: () => employeeApi.directory() });

  return (
    <div className="page">
      <Link to="/staff">&larr; Back to Dashboard</Link>
      <PageHeader title="Staff Directory" />
      {directoryQuery.data && (
        <DataTable
          rows={directoryQuery.data.data}
          rowKey={(e) => e.id}
          emptyMessage="No staff records yet."
          columns={[
            { header: 'Name', render: (e) => e.full_name },
            { header: 'Position', render: (e) => e.position_name ?? '-' },
            { header: 'Department', render: (e) => e.department_name ?? '-' },
            { header: 'Duty Station', render: (e) => e.duty_station_name ?? '-' },
            { header: 'Email', render: (e) => e.official_email },
          ]}
        />
      )}
    </div>
  );
}
